import { FC, ReactElement } from 'react';

import { components, SingleValueProps } from 'react-select';

import { FormImageOption } from '../../../../../entities/@forms/Form/Form';

const { SingleValue } = components;

export const SelectLabel: FC<SingleValueProps<FormImageOption, false>> = (
    props,
): ReactElement => {
    const { data } = props;

    return (
        <SingleValue {...props}>
            <p>{data.label}</p>
        </SingleValue>
    );
};
